<template>
  <div>
    <v-card width="400">
      <v-card-title>
        <DialogTitle :dialogName="$options.name">
          {{ isEditMode ? 'Edit' : 'New' }} Measure Type
        </DialogTitle>
      </v-card-title>
      <v-card-text v-if="formData">
        <v-text-field
          v-model="formData.Code"
          label="Code"
          :error-messages="errorMessages(vuelidate.formData.Code)"
          @blur="vuelidate.formData.Code.$touch()"
          dense
        />
        <v-text-field
          v-model="formData.Description"
          label="Description"
          :error-messages="errorMessages(vuelidate.formData.Description)"
          @blur="vuelidate.formData.Description.$touch()"
          dense
        />
        <v-text-field
          v-model="formData.SortOrder"
          label="Sort Order"
          type="number"
          :error-messages="errorMessages(vuelidate.formData.SortOrder)"
          @blur="vuelidate.formData.SortOrder.$touch()"
          dense
        />
        <v-currency-field
          v-model="formData.LowValue"
          label="Lowest measureable value"
          :error-messages="errorMessages(vuelidate.formData.LowValue)"
          @blur="vuelidate.formData.LowValue.$touch()"
          dense
        />
        <v-currency-field
          v-model="formData.HighValue"
          label="Highest measureable value"
          :error-messages="errorMessages(vuelidate.formData.HighValue)"
          @blur="vuelidate.formData.HighValue.$touch()"
          dense
        />
        <v-currency-field
          v-model="formData.StepValue"
          label="Step Value"
          :error-messages="errorMessages(vuelidate.formData.StepValue)"
          @blur="vuelidate.formData.StepValue.$touch()"
          dense
        />
        <v-currency-field
          v-model="formData.NormalLowValue"
          label="Low value of normal range"
          dense
        />
        <v-currency-field
          v-model="formData.NormalHighValue"
          label="High value of normal range"
          dense
        />
        <v-currency-field
          v-model="formData.AlertLowValue"
          label="Show as alert if value lower than"
          dense
        />
        <v-currency-field
          v-model="formData.AlertHighValue"
          label="Show as alert if value higher than"
          dense
        />
        <v-checkbox
          v-model="formData.IsRequired"
          label="Required to close service"
          dense
        />
      </v-card-text>
      <v-card-actions
        ><v-btn color="success" class="ml-1" @click="saveClick">{{
          isEditMode ? 'Update' : 'Save'
        }}</v-btn>
        <v-btn color="error" class="ml-3" @click="cancelClick">Cancel</v-btn>
      </v-card-actions>
    </v-card>

    <DialogUtil ref="dialogUtil" />
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { host } from '@/services/HostAPI'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {
  name: 'MeasureTypeEditor',
  props: {
    infoId: {
      type: String,
      default: null
    },
    isDialogOpen: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const dialogUtil = ref()

    const isEditMode = ref(false)
    const formData = ref()

    watch(
      () => props.isDialogOpen,
      newVal => {
        newVal && initDialog()
      }
    )

    const initDialog = () => {
      isEditMode.value = props.infoId != null
      if (isEditMode.value) {
        loadMeasureType()
      } else {
        initNewMeasureType()
      }
      vuelidate.value.$reset()
    }

    const saveClick = async () => {
      if (isInvalid()) {
        return
      }

      const result = isEditMode.value ? await update() : await saveNew()
      console.log({
        loc: 'MeasureTypeEditor.saveClick',
        result
      })
      afterSaveOrUpdate(result)
    }

    const cancelClick = () => {
      context.emit('close')
    }

    const afterSaveOrUpdate = result => {
      if (result.IsSuccess) {
        context.emit('update')
      } else {
        dialogUtil.value.error(result.Message)
      }
    }

    const rules = {
      formData: {
        Code: { required },
        Description: { required },
        SortOrder: { required },
        LowValue: { required },
        HighValue: { required },
        StepValue: { required }
      }
    }

    const vuelidate = useVuelidate(rules, { formData })

    const errorMessages = item => {
      return vuelidate.value.$invalid ? item.$errors.map(e => e.$message) : []
    }

    const isInvalid = () => {
      vuelidate.value.$touch()
      console.log({
        loc: 'MeasureTypeEditor.isInvalid ',
        invalid: vuelidate.value.$invalid
      })
      return vuelidate.value.$invalid
    }

    const loadMeasureType = async () => {
      const rq = { InfoId: props.infoId }
      const rs = await host.measureType.retrieve(rq)
      formData.value = rs.Info
    }

    const saveNew = async () => {
      const rq = { Info: formData.value }
      const rs = await host.measureType.create(rq)
      return rs
    }

    const update = async () => {
      const rq = { Info: formData.value }
      const rs = await host.measureType.update(rq)
      return rs
    }

    const initNewMeasureType = () => {
      formData.value = {
        Id: null,
        Code: null,
        Description: null,
        SortOrder: 0,
        LowValue: 0,
        HighValue: 100,
        StepValue: 10
      }
    }

    initDialog()
    return {
      dialogUtil,
      isEditMode,
      formData,
      errorMessages,
      saveClick,
      cancelClick,
      vuelidate
    }
  }
}
</script>

<style lang="scss" scoped></style>
